<template>
   <CardOutline class="__clickable">
      <div class="flex items-center gap-10 p-4">
         <div class="flex items-center gap-3">
            <div class="rounded-small size-10 overflow-hidden">
               <Image :src="image" class="size-full object-cover" />
            </div>
            <p>
               {{ email }}
            </p>
         </div>
         <div class="ml-auto">
            <p class="text-grey">
               {{ t(`enum.${role}`) }}
            </p>
         </div>
      </div>
   </CardOutline>
</template>

<script lang="ts" setup>
import type { Enums } from '@xleddyl/types'

type Props = {
   image?: string | null
   email?: string | null
   role: Enums<'USER_ORGANIZATION_ROLE_TYPE'>
}

const props = withDefaults(defineProps<Props>(), {})

const { t } = useI18n()
</script>
